import { api } from '@/services/api/main/axios';
import config from '@/config';

export interface LoginMemberForm {
  userId: string;
  email: string;
  password: string;
  rememberMe: boolean;
  recaptchaResponse: string;
}

export const loginMemberApiRequest = async (form: LoginMemberForm) => {
  return api.post('auth/login/member', {
    userId: form.userId,
    login: form.email,
    password: form.password,
    rememberMe: form.rememberMe,
    recaptchaResponse: form.recaptchaResponse,
    site_id: config.api.site_id,
  });
};
